import { SimpleChannel } from '@ibe/services';

export const cookieConsentChangeEvent = new SimpleChannel('cookie-consent-change-event');
